import Vue from 'vue'

export const userKey = process.env.VUE_APP_USER_KEY || 'kdjskjdkshdhsj'
export const urlApi = process.env.VUE_APP_API_URL || 'http://localhost:1020'

function extrairMensagemErro(payload) {
    if (!payload) return ''
    if (typeof payload === 'string') return payload
    if (Array.isArray(payload)) return payload.map(extrairMensagemErro).filter(Boolean).join(' | ')
    if (typeof payload === 'object') {
        return payload.error || payload.message || payload.msg || ''
    }
    return String(payload)
}

export function showError(e, msgPersonalizada) {
    if (e && e.response && e.response.data) {
        const msg = extrairMensagemErro(e.response.data)
        if (msg) {
            Vue.toasted.global.defaultError({ msg })
            return
        }
        Vue.toasted.global.defaultError()
    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultError({
            msg: msgPersonalizada ? `${e}${msgPersonalizada}` : e
        })
    } else {
        const msg = extrairMensagemErro(e)
        if (msg) {
            Vue.toasted.global.defaultError({
                msg: msgPersonalizada ? `${msg}${msgPersonalizada}` : msg
            })
            return
        }
        Vue.toasted.global.defaultError()
    }
}

export default { urlApi, showError }
